export default [
  // {
  //   id: "001",
  //   category: "Shopify",
  //   mainClass: "col-lg-4 col-md-6 col-sm-6 col-xs-12 mix react shopify",
  //   imgSrc: "wizza.png",
  //   projectUrl: "https://www.wizza.com/",
  //   summary: "Sweepstakes - eCommerce Platform",
  //   stack: "Stack: Javascript, Typescript, Shopify, Shopify Plus, React.js, Nodejs, Expressjs, Serverless, and AWS Lambda, DynamoDB, Amplify",
  // },
  // {
  //   id: "001",
  //   category: "react",
  //   mainClass: "col-lg-4 col-md-6 col-sm-6 col-xs-12 mix react dataviz python",
  //   imgSrc: "kasaz.png",
  //   projectUrl: "https://www.kasaz.com/",
  //   summary: "RealEstate Website - Kasaz",
  //   stack: "Stack: ReactJS, React Native, Redux, Angular, Nodejs, Ruby on Rails, GraphQL, PostgreSQL",
  // },
  // {
  //   id: "001",
  //   category: "react",
  //   mainClass: "col-lg-4 col-md-6 col-sm-6 col-xs-12 mix react dataviz python",
  //   imgSrc: "NewMarketingAnalyticsPerx.png",
  //   projectUrl: "https://www.perxtech.com/",
  //   summary: "Marketing Analytics Platform - Perx",
  //   stack: "Stack: ReactJS, React Hooks, Video Streaming, PHP",
  // },
  // {
  //   id: "001",
  //   category: "react",
  //   mainClass: "col-lg-4 col-md-6 col-sm-6 col-xs-12 mix react node",
  //   imgSrc: "NewVideoEducationalWebsite.png",
  //   projectUrl: "https://www.masterclass.com/",
  //   summary: "Online Video Education Website",
  //   stack: "Stack: Typescript, React.js, React Hooks, Styled-components, CMS",
  // },
  {
    id: "001",
    category: "react",
    mainClass: "col-lg-4 col-md-6 col-sm-6 col-xs-12 mix react dataviz node",
    imgSrc: "NewMarketingAnalyticsPlatform.png",
    projectUrl: "https://www.10thman.media/",
    summary: "Performance marketing analytics and data visualization platform",
    stack: "Stack: TypeScript, React.js, D3.js, Next.js, Redux, Redux-saga, Recharts, C#, Azure",
  },
  {
    id: "001",
    category: "angular",
    mainClass: "col-lg-4 col-md-6 col-sm-6 col-xs-12 mix angular python",
    imgSrc: "NewSaffronVC.png",
    projectUrl: "https://saffron.vc/",
    summary: "Saffron helps entrepreneurs create and track business progress",
    stack:
      "Stack: Typescript, Angular 8, NgRx, Twillio, Document management services, Google Doc , Python, Django, Django RestFramework",
  },
  {
    id: "001",
    category: "reactnative",
    mainClass: "col-lg-4 col-md-6 col-sm-6 col-xs-12 mix reactnative",
    imgSrc: "NewAIDatingApp.png",
    projectUrl: "https://matchmde.com/",
    summary: "AI Dating App",
    stack: "Stack: Javascript, ReactJS, React Native, Redux-saga, Nodejs, Firebase",
  },
  {
    id: "001",
    category: "angular",
    mainClass: "col-lg-4 col-md-6 col-sm-6 col-xs-12 mix angular dataviz ruby",
    imgSrc: "NewEquiteIO.png",
    projectUrl: "https://www.equite.io/",
    summary: "Social Medial Paltform",
    stack: "Stack: ReactJS, React Hooks, Video Streaming, PHP",
  },
  {
    id: "001",
    category: "react",
    mainClass: "col-lg-4 col-md-6 col-sm-6 col-xs-12 mix react ruby",
    imgSrc: "NewEcommerceWebsiteInstitchu.png",
    projectUrl: "https://institchu.com/",
    summary: "Online wellness solutions and plans Platform for common users",
    stack: "Stack: Javascript, ReactJS, Redux, GraphQL, GraphQL-Relay, React Hooks, Nodejs",
  },
  {
    id: "001",
    category: "flutter",
    mainClass: "col-lg-4 col-md-6 col-sm-6 col-xs-12 mix flutter",
    imgSrc: "NewBusinessChatApp.png",
    projectUrl: "https://apps.apple.com/us/app/id1491054470#?platform=iphone",
    summary: "BusinessChat",
    stack:
      "Stack: React Native, Redux, Javascript, Material UI, Python, NLTK, Scrapping, Social Network",
  },
  {
    id: "001",
    category: "reactnative",
    mainClass: "col-lg-4 col-md-6 col-sm-6 col-xs-12 mix reactnative",
    imgSrc: "NewTrotterTravelPlanner.png",
    projectUrl: "https://apps.apple.com/au/app/trotter-travel-planner/id1390522700",
    summary: "Trotter Travel Planner App",
    stack: "Stack: Flutter, Dart",
  },
  {
    id: "001",
    category: "react",
    mainClass: "col-lg-4 col-md-6 col-sm-6 col-xs-12 mix react node",
    imgSrc: "NewObsChart.png",
    projectUrl: "https://obschart.com/",
    summary: "Online wellness solutions and plans Platform for common users",
    stack: "Stack: Javascript, ReactJS, Redux, GraphQL, GraphQL-Relay, React Hooks, Nodejs",
  },
  // {
  //   id: "001",
  //   category: "vue",
  //   mainClass: "col-lg-4 col-md-6 col-sm-6 col-xs-12 mix vue",
  //   imgSrc: "NewEsportsBetting.png",
  //   projectUrl: "https://www.rivalry.com/",
  //   summary: "Trusted eSports Betting Platform",
  //   stack: "Stack: Vue.js, Vuex, Nuxt.js",
  // },
  {
    id: "001",
    category: "react",
    mainClass: "col-lg-4 col-md-6 col-sm-6 col-xs-12 mix react",
    imgSrc: "NewChangePlan.png",
    projectUrl: "https://changeplan.herokuapp.com/",
    summary: "Trusted eSports Betting Platform",
    stack: "Stack: Vue.js, Vuex, Nuxt.js",
  },
];
